import React, { useCallback } from 'react';
import { Formik } from 'formik';
import { useTranslation, TFunction } from 'react-i18next';
import UDFormInput from '../../../../ud-form/components/input';
import UDFormTextearea from '../../../../ud-form/components/input/textarea';
import UDFormSelect from '../../../../ud-form/components/select';
import { SportType } from '../../../../core/domain/enums/SportType';
import { OrganizerUpsertPayload } from '../../../domain/interfaces/OrganizerUpsertPayload';
import UDButton from '../../../../ud-ui/components/button';
import UDFormDropZone from '../../../../ud-form/components/dropzone';
import styled from '@emotion/styled';

type OrganizerLogoProps = {
  url: string;
  size: number;
};

const OrganizerLogo = styled.div<OrganizerLogoProps>`
  background: url(${(props) => props.url}) no-repeat center;
  background-size: contain;
  border: 1px solid ${({ theme }) => theme.colors.SurfacePlatinum20};
  border-radius: 8px;
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
`;

const sportTypeToSelectOption = (sportTypeKey: string, t: TFunction) => ({
  label: t(`sportType.${sportTypeKey}`),
  value: sportTypeKey,
});

const sportTypesToSelectOptions = (t: TFunction) =>
  Object.keys(SportType).map((sportType) =>
    sportTypeToSelectOption(sportType, t)
  );

type OrganizerFormProps = {
  initialValues?: OrganizerUpsertPayload;
  onSubmit: (values: OrganizerUpsertPayload) => void;
};

export const OrganizerForm = (props: OrganizerFormProps) => {
  const { t } = useTranslation();
  const sportTypeOptions = sportTypesToSelectOptions(t);
  const { initialValues, onSubmit } = props;

  const values = props.initialValues;
  const logoUrl = values?.logoUrl;

  const initialFormValues = props.initialValues
    ? {
        ...initialValues,
        sportType: initialValues
          ? sportTypeToSelectOption(initialValues.sportType, t)
          : sportTypeToSelectOption(SportType.football, t),
      }
    : {
        name: '',
        sportType: sportTypeToSelectOption(SportType.football, t),
      };

  const handleSubmit = useCallback(
    (values) => {
      onSubmit({
        ...values,
        sportType: values.sportType.value,
      });
    },
    [onSubmit]
  );

  return (
    <Formik initialValues={initialFormValues} onSubmit={handleSubmit}>
      {(formProps) => (
        <form onSubmit={formProps.handleSubmit}>
          <div className="row g-2">
            <div className="col-6">
              <UDFormInput
                name="name"
                label="Название огранизации"
                placeholder="Введите название"
                containerProps={{ className: 'mb-5' }}
              />

              <UDFormSelect
                name="sportType"
                label="Тип спорта"
                placeholder="Выберите тип спорта"
                isMulti={false}
                options={sportTypeOptions}
                containerProps={{ className: 'mb-5' }}
              />

              <UDFormInput
                name="email"
                label="Email"
                placeholder="Email"
                containerProps={{ className: 'mb-5' }}
              />

              <UDFormInput
                name="phone"
                label="Телефон"
                placeholder="+7"
                containerProps={{ className: 'mb-5' }}
              />

              <UDFormTextearea
                name="description"
                label="Описание"
                placeholder="Введите текст"
                containerProps={{ className: 'mb-5' }}
              />
            </div>
            <div className="col-1"></div>
            <div className="col-5">
              {logoUrl && (
                <div className="mb-4">
                  <OrganizerLogo url={logoUrl} size={150} />
                </div>
              )}

              <UDFormDropZone
                name="logo"
                label="Загрузить логотип"
                value={[]}
                isCover={true}
                formProps={{ className: 'bgc-SurfaceWhite br-8 p-6' }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-6 mb-2">
            <UDButton variant="primary" type="submit" className="mb-3">
              Сохранить
            </UDButton>
          </div>
        </form>
      )}
    </Formik>
  );
};
